import React, { useEffect, useState } from "react";
import "./Orders.css";
//import { useStateValue } from "./StateProvider";
import { db } from "./firebase";
import Order from "./Order";
import { useSelector } from "react-redux";
import { selectUser } from "./redux/cart/cartSlice";

function Orders() {
  //  const [{ basket, user }, dispatch] = useStateValue([]);
  const [orders, setOrders] = useState([]);
  const state = useSelector(selectUser);

  useEffect(() => {
    if (state.user) {
      db.collection("users")
        .doc(state.user?.uid)
        .collection("orders")
        .orderBy("created", "desc")
        .onSnapshot((snapshot) =>
          setOrders(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }))
          )
        );
    } else {
      setOrders([]);
    }
  }, [state.user]);

  return (
    <div className="orders">
      <h1 className="orders__heading">Your Orders</h1>
      <div className="orders__order">
        {orders?.length === 0 ? (
          <img
            src="https://cdn.dribbble.com/users/1555425/screenshots/4811660/no_order_found_1x.jpg"
            alt=""
          />
        ) : (
          orders?.map((order) => <Order order={order} />)
        )}
      </div>
    </div>
  );
}

export default Orders;
